import { render, staticRenderFns } from "./Login-rekomendasi.vue?vue&type=template&id=33a6b4e0"
import script from "./Login-rekomendasi.vue?vue&type=script&lang=js"
export * from "./Login-rekomendasi.vue?vue&type=script&lang=js"
import style0 from "./Login-rekomendasi.vue?vue&type=style&index=0&id=33a6b4e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports